export default __webpack_public_path__ + "static/media/step_4.c394e200.svg";